import { Base } from './_base.model';

export class SpeakerSelection extends Base {
  id: string;
  contract: string;
  topic: string;
  compliance: string;
  bureau_exclude: string[];
  bureau_include: string[];
  type: string;
  message: string;
}
